import React, { FC } from 'react'

import { NavWrap, Button } from './styled'

import { LogoLink } from 'src/components/LogoLink/LogoLink'
import { InviteIcon } from 'src/components/Icons'
import { InviteModal } from 'src/components/InviteModal/InviteModal'

type HeaderProps = {
  withInvite?: boolean
}

const Header: FC<HeaderProps> = ({ withInvite }) => {
  const [inviteModalOpen, setInviteModalOpen] = React.useState(false)

  return (
    <>
      <NavWrap>
        <LogoLink />
        {withInvite && (
          <Button onClick={() => setInviteModalOpen(true)}>
            <InviteIcon />
          </Button>
        )}
      </NavWrap>
      <InviteModal
        isOpen={inviteModalOpen}
        onClose={() => setInviteModalOpen(false)}
      />
    </>
  )
}

export default Header
